import { render } from "./Inventory_CatalogItem_Dialog.vue?vue&type=template&id=bff1c68c&scoped=true&ts=true"
import script from "./Inventory_CatalogItem_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_CatalogItem_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_CatalogItem_Dialog.vue?vue&type=style&index=0&id=bff1c68c&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bff1c68c"]])

export default __exports__